import { Component, OnInit } from '@angular/core';
import { Transparencia } from '../../model/transparencia/transparencia.model';
import { Mes } from '../../model/transparencia/mes.model';
import { Anio } from '../../model/transparencia/anio.model';
import { TransparenciaService } from '../../service/transparencia/transparencia.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { YearAccountability } from '../../controller/accountability.interface';
import { MachalaEpService } from 'src/app/service/service/machala-ep.service';

// declare let $: any;

@Component({
  selector: 'app-transparency',
  templateUrl: './transparency.component.html',
  styleUrls: ['./transparency.component.scss'],
})
export class TransparencyComponent implements OnInit {
  public transparencias: Transparencia[];
  public meses: Mes[];
  public anios: Anio[];
  public aniosL;
  accountabilities: YearAccountability[] = [];
  selectedOptionM: string;
  selectedOptionA: string;
  printedOption: string;
  constructor(
    private transparenciaService: TransparenciaService,
    private spinner: NgxSpinnerService,
    private machalaEp: MachalaEpService
  ) {
    this.getAnioTransparencia();
  }

  ngOnInit(): void {
    this.getAccountabilities();
    window.scrollTo(0, 0);

    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1500);
  }

  public getDocsTransparencia(anioS: string, mesS: string) {
    this.spinner.show();
    this.transparenciaService
      .getDocsTransparencia(mesS, anioS)
      .subscribe((transparencias) => (this.transparencias = transparencias));
    this.spinner.hide();
  }

  public getMesTransparencia() {
    this.spinner.show();
    var slt_anio = (<HTMLInputElement>document.getElementById('selectAnioD'))
      .value;
    this.transparenciaService
      .getMesTransparencia(slt_anio)
      .subscribe((meses) => (this.meses = meses));
    this.spinner.hide();
  }
  public getAnioTransparencia() {
    this.spinner.show();

    this.transparenciaService.getAnioTransparencia().subscribe((anios) => {
      this.anios = anios;
      this.anios.unshift(new Anio('-Seleccione un año-'));
    });
    this.spinner.hide();
  }
  public buscarDocumentos() {
    var anioS = (<HTMLInputElement>document.getElementById('selectAnioD'))
      .value;
    var mesS = (<HTMLInputElement>document.getElementById('selectMesD')).value;
    var mesesList = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    var indexMes = mesesList.indexOf(mesS) + 1;
    this.transparencias = [];
    this.spinner.show();
    this.getDocsTransparencia(anioS, indexMes.toString());
    this.spinner.hide();
  }
  public openPDFFile(url: string) {
    window.open(url, '_blank');
  }
  public downloadPDFFile(url: string) {
    var urlArray = url.split('/');
    var filename = urlArray[urlArray.length - 1];
    fetch(url).then(function (t) {
      return t.blob().then((b) => {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(b);
        a.setAttribute('download', filename);
        a.click();
      });
    });
  }
  getAccountabilities(): void {
    this.machalaEp.obtenerRendiciondeCuentas().subscribe((resp) => {
      this.accountabilities = resp;
    });
  }
}
